import React from "react";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../../assets/icons";
const SearchInput = ({ placeholder, width, border, setSearchVal, onClick }) => {
  return (
    <div
      className={`w-full bg-white relative border rounded-lg flex items-center border-gray-300 px-[10px] text-secondary-800 placeholder-[#667085]  h-9`}
      style={{
        boxShadow: "0px 1.5px 2px rgba(16, 24, 40, 0.1)",
        width: width,
        border: border,
      }}
    >
      <SearchIcon className="w-5 h-5" />
      <input
        className="w-full h-full ml-1.5 text-xs  text-secondary-800 focus:outline-none focus:border-none "
        placeholder={placeholder}
        onChange={(e) => setSearchVal(e.target.value)}
        onClick={onClick}
      />
    </div>
  );
};

export default SearchInput;
